// import "./../../vendor/bootstrap.min";
import moment from 'moment/moment';
import CountDown from "./CountDown";
import Cookies from 'js-cookie'
const { __ } = wp.i18n;


(function($) {
    let localData = {...AA_Data};
    $(document).ready(function () {
        let webinarModalLink = $('a[href="#webinar-modal"]');

        if (webinarModalLink.length > 0) {
            let modal = $('#webinar-modal');
            modal.remove()
            $('body').append(modal)
            webinarModalLink.click(e => {
                e.preventDefault();
                modal.modal();
            });

            var sessionSelect = $('#webinar-modal select');
            setSessions(sessionSelect);
            setSelect(sessionSelect);
            // $('#webinar-modal').modal();

            let name = modal.find('input[name="name"]');
            name.bind('keyup blur', function() {
                var node = jQuery(this);
                node.val(node.val().replace(/[^a-zA-Zà-úÀ-Ú˜'ˆ \.,]/g, ''));
            });

            submitWebinarForm();
        }

        if (document.URL.indexOf('/webinar/') >= 0) {
            let eecm = Cookies.get('eecm');
            let aawn = Cookies.get('aawn');
            eecm = (eecm ? eecm : '').split(':');
            aawn = aawn ? aawn : '';
            let validity = typeof eecm[2] === 'undefined' || eecm[2] === '1';
            let validAccess = eecm.length >= 2 && eecm[0] && eecm[1] && validity && aawn.length > 6;
            if (! validAccess) AAEF.showValidationModal('aa_webinar_access_validation');
        }

        $('.aa-webinar-countdown').each(function (i, e) {
            let el = $(e);
            let url = el.data('url');
            new CountDown(el.data('time'), el, function(){
                document.location = url;
            }, function(time){
                time = CountDown.getDHMSFormat(time);

                return `<div><span class="time">${time.d}</span><span>Dias</span></div><div><span class="time">${time.h}</span><span>Hrs</span></div><div><span class="time">${time.m}</span><span>Min</span></div><div><span class="time">${time.s}</span><span>Seg</span></div>`;
            });
        });

        $('.aa-webinar-date').each(function (i, e) {
            let el = $(e), html, date;
            date = moment(el.data('time') * 1000);
            html = '<div class="text-center"><p style="margin-bottom: 1em"><img src="/wp-content/plugins/aa-webinars/images/calendar-140.png" width="70" height="70" /></p>';
            html += '<p class="date">';
            html += date.format('dddd, DD MMMM Y, hh:mm A');
            html += '</p>';
            el.html(html);
        });
    });

    function hide_error(form) {
        form.find('.alert').remove()
    }

    function show_form_error (form, msg) {
        hide_error(form);
        let fields = form.find('.form-fields')
        if (fields.length)
            fields.after(`<div class='alert alert-danger'>${msg}</div>`)
        else
            form.find('.buttons').before(`<div class='alert alert-danger'>${msg}</div>`)
    }

    function setSessions(sessionSelect) {
        var now = moment();
        var date = now.clone().minutes(0).seconds(0);
        var list = [
            {value: 0, label: sessionSelect.children('option').eq(0).text()},
            {value: 0, label: __( 'Agora', 'aa-webinars' )},
            // {value: '1 min', label: '1 Minute'}
        ];
        // if (date.hours() >= 21) date.add(1,  'day');
        // date = date.hours(21);
        // let day = now.day() === date.day() ? '\\H\\o\\j\\e' : '\\A\\m\\a\\n\\h\\ã';
        // list.push(
        //     {value: date.toISOString(), label: date.format(day + ' \\à\\s HH:mm')}
        // );

        // if (date.hours() > 22) date.add(1,  'day');
        // let day, hour;
        // for (let k=0; k < 17; k++) {
        //     if (date.day() === now.day() && 6+k <= now.hours()) continue;
        //     day = now.day() === date.day() ? '\\H\\o\\j\\e' : 'DD/MM';
        //     hour = 6 + k;
        //     date = date.hours(hour);
        //     list.push(
        //         {value: date.toISOString(), label: date.format(day + ' \\à\\s HH:mm')}
        //     );
        // }

        var options = list.map(function(item) {
            return `<option value="${item['value']}">${item['label']}</option>`;
        }).join('');
        sessionSelect.html(options);
    }

    function setSelect($this) {

        var numberOfOptions = $this.children('option').length;

        $this.addClass('hidden');
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="select-styled"></div>');

        var $styledSelect = $this.next('div.select-styled');
        $styledSelect.text($this.children('option').eq(0).text());

        var $list = $('<ul />', {
            'class': 'select-options'
        }).insertAfter($styledSelect);

        for (var i = 1; i < numberOfOptions; i++) {
            $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
        }

        var $listItems = $list.children('li');

        $styledSelect.click(function (e) {
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function () {
                $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
        });

        $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
            $list.closest('form').find('input[type=text]').eq(0).focus();
        });

        $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
        });
    }

    function submitWebinarForm() {
        let form = $('#webinar-lightbox-form'),
            emailField = form.find('input[name="email"]')
        form.submit(function(e){
            e.preventDefault();
            hide_error(form);
            if (AAEF.aaEmailValidate(emailField.val())) {
                let data = form.serialize() + '&action=aa_webinar_subscription&main-page=' + localData.p + '&referer=' + window.location.href;
                jQuery.post(localData.ajax_url, data, function(data){
                    if (data['success'] === true && typeof data['data']['url'] !== 'undefined') {
                        document.location = data['data']['url'];
                    } else {
                        show_form_error(form, AAEF_Data.i18n.invalid)
                    }
                });
            } else {
                show_form_error(form, AAEF_Data.i18n.invalid)
            }
        });
    }
})(jQuery);
// jQuery('#payment-modal').modal();